(function () {
  function mount(container) {
    if (!container || container.dataset.mounted === 'true') return;
    container.dataset.mounted = 'true';

    var outputs = container.querySelectorAll('.aeliza-announcement__typed');
    var text = container.getAttribute('data-text') || '';
    if (!outputs.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      outputs.forEach(function (output) { output.textContent = text; });
      return;
    }

    outputs.forEach(function (output) { output.textContent = ''; });
    var index = 0;

    function typeNext() {
      if (index >= text.length) return;
      var character = text.charAt(index);
      outputs.forEach(function (output) { output.textContent += character; });
      index += 1;
      window.setTimeout(typeNext, 42);
    }

    window.setTimeout(typeNext, 180);
  }

  function mountAll(root) {
    (root || document).querySelectorAll('[data-announcement-typewriter]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { mountAll(event.target); });
})();
